module.exports = __webpack_public_path__ + "img/I-07057_95-e.42b537e1.jpg";